import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { MapStringTo, Nullable } from "../base-types";
import { MinimalSchema } from "../contracts/querying/minimal-schema";
import { EntityResource } from "./entity-resource";
import { ListResource } from "./list-resource";

@JsonObject()
export class EntityCollectionResource extends ListResource<EntityResource> {
    @JsonProperty("items")
    @JsonElementType(EntityResource)
    items: Array<EntityResource>;

    @JsonProperty("last_hit_data")
    @JsonElementType(String)
    lastHitData?: Nullable<Array<string>>;

    @JsonProperty("minimal_schema_list")
    minimalSchemaList?: MapStringTo<MinimalSchema>;
}
